// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3IyYw","resendInfoText":"OnGoingPaymentBox_resendInfoText__1r2Kt"};